var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChatBatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 29.7298578 30.5914692 29.7298578 30.5914692 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 30.591455 0 30.591455 29.7298009 0 29.7298009"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cosmetic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-5-Map-",
    transform: "translate(-364.000000, -691.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(209.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 38.000000)",
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.014218)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2957346,0 C6.86161137,0 0,6.06383886 0,13.5172038 C0,18.1771564 2.6643128,22.4493839 7.12720379,24.9464929 L7.4428436,25.122654 L7.34090047,25.4702844 C6.85393365,27.1300948 5.67483412,28.7664455 4.99706161,29.613981 C5.48118483,29.6937441 5.96218009,29.7298578 6.43549763,29.7298578 C9.77203791,29.7298578 12.7080569,27.9322749 13.4097156,26.9026066 L13.5449289,26.7041232 L13.7849289,26.7041232 C20.5542654,26.7041232 25.3585308,24.9749289 28.0512796,21.6328436 C29.7319905,19.5470616 30.5914692,16.8328436 30.5914692,13.5172038 C30.5914692,7.01758294 25.3730332,1.57450237 18.4441706,0.288483412 C17.4280095,0.0998104265 16.3750237,0 15.2957346,0 M15.2957346,2.08094787 C16.2265877,2.08094787 17.1580095,2.16625592 18.0644076,2.33459716 C21.0100948,2.88127962 23.6836493,4.31260664 25.5922749,6.36511848 C26.5238389,7.36649289 27.2479621,8.48331754 27.7448815,9.68445498 C28.252891,10.9126066 28.5105213,12.2020379 28.5105213,13.5172038 C28.5105213,16.3235545 27.8108531,18.6147867 26.4308531,20.327346 C25.3322275,21.6908531 23.7565877,22.745545 21.7478673,23.4618483 C19.5865877,24.2324645 13.5449289,24.6233175 13.5449289,24.6233175 L12.4451659,24.6233175 C12.4451659,24.6233175 11.0591943,26.3496682 9.94947867,26.853981 C9.6564455,26.9872038 9.30156398,27.1296682 8.89734597,27.2567773 C9.06824645,26.8653555 9.90725118,24.1150237 9.90725118,24.1150237 L8.14336493,23.1305687 C4.34729858,21.0063981 2.08094787,17.412654 2.08094787,13.5172038 C2.08094787,10.517346 3.42412322,7.67829384 5.86308057,5.52298578 C7.07758294,4.44952607 8.49554502,3.6049763 10.0772986,3.01265403 C11.7287204,2.39445498 13.4843602,2.08094787 15.2957346,2.08094787",
    id: "Fill-1",
    stroke: "none",
    fill: "#818181",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#818181",
    mask: "url(#mask-2)",
    points: "11 12.3872512 22.7072512 12.3872512 22.7072512 11 11 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#818181",
    mask: "url(#mask-2)",
    points: "8 15.3873934 19.707109 15.3873934 19.707109 14 8 14"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatBatch);
export default __webpack_public_path__ + "static/media/icon_chat_batch.a45a0c37ef99097529d68351d0829f09.svg";
export { ForwardRef as ReactComponent };